// Centralized auth token access.
// Reads cookie 'token' (single source of truth).

export interface AuthTokenProvider {
  getToken(): string | null;
}

class CookieAuthTokenProvider implements AuthTokenProvider {
  private cookieName = 'token';
  getToken(): string | null {
    try {
      const cookie = document.cookie;
      const match = cookie.match(new RegExp('(?:^|; )' + this.cookieName + '=([^;]+)'));
      if (match) return decodeURIComponent(match[1]);
    } catch {}
    return null;
  }
}

let _authTokenProvider: AuthTokenProvider | null = null;
export function authTokenProvider(): AuthTokenProvider {
  if (!_authTokenProvider) _authTokenProvider = new CookieAuthTokenProvider();
  return _authTokenProvider;
}

export function getAuthToken(): string | null {
  return authTokenProvider().getToken();
}